<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>发票申请列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="tabIndex" @tab-click="handleClick">
      <el-tab-pane v-for="item in statusOptions" :key="item.id" :label="item.value"></el-tab-pane>
    </el-tabs>

    <el-card>
      <el-row v-if="canLook == 1">
        <el-col :span="5">
          <el-input placeholder="请输入订单号" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>

        <el-col :span="5">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.agencyName" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>

        <el-col :span="8">
          <a class="aaaa" :href="exportUrl + '?query=' + queryInfo.query + '&tid=' + queryInfo.tid + '&agencyName=' + queryInfo.agencyName + '&status=' + queryInfo.status">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index"></el-table-column>

        <el-table-column label="所选的商品信息" type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.goods_info" border stripe ref="xxxTable" tooltip-effect="dark" style="width: 60%">
              <el-table-column label="订单号" prop="order_id"> </el-table-column>
              <el-table-column label="名称" prop="title"> </el-table-column>
              <el-table-column label="单价" prop="price"> </el-table-column>
              <el-table-column label="购买数量" prop="buyNum"> </el-table-column>
              <el-table-column label="赠送数量" prop="sendNumber" width="120px"> </el-table-column>
              <el-table-column label="活动" prop="activityContent" width="150px"> </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="开票单号" prop="order_id" width="90px"></el-table-column>
        <el-table-column label="经销商" prop="agencyName" width="100px"></el-table-column>

        <el-table-column align="center" width="140px">
          <template slot="header" slot-scope="scope">
            <el-select v-model="typeValue" size="mini" @change="changeType" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.index == 0">增值税普通电子发票</div>
            <div v-if="scope.row.index == 1">增值税专用发票</div>
            <div v-if="scope.row.index == 2">增值税普通发票</div>
          </template>
        </el-table-column>

        <el-table-column label="发票抬头" prop="invoice_title" align="center" width="120px"> </el-table-column>
        <el-table-column label="税号" prop="invoice_tax_no" width="140px"></el-table-column>
        <el-table-column label="金额" prop="money" width="70px"></el-table-column>
        <el-table-column label="地址" prop="address" width="100px"></el-table-column>
        <el-table-column label="电话" prop="phone" width="90px"></el-table-column>
        <el-table-column label="邮箱" prop="email" width="100px"></el-table-column>
        <el-table-column label="开户行" prop="bankLocation" width="80px"></el-table-column>
        <el-table-column label="银行账户" prop="bank" width="80px"></el-table-column>
        <!-- <!-- 0待审核1通过2拒绝3已完成  -->
        -->
        <el-table-column label="状态" prop="status" width="120px">
          <!-- <template slot="header" slot-scope="scope">
            <el-select v-model="statusValue" size="mini" @change="changeInvoiceStatus" placeholder="请选择">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template> -->

          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status == '0'">待审核</el-tag>
            <el-tag class="daiqueren" v-if="scope.row.status == '1'">已审核，待开具</el-tag>
            <el-tag class="daifahuo" v-if="scope.row.status == '2'">已拒绝</el-tag>
            <el-tag class="yifahuo" v-if="scope.row.status == '3'">已完成开具</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="拒绝原因" v-if="tabIndex == 4 || tabIndex == 0" prop="refuseseasion" width="120px"></el-table-column>

        <el-table-column label="申请时间" prop="create_at" width="80px"> </el-table-column>

        <el-table-column label="开票信息" width="200px">
          <!-- //0待审核 1通过 2拒绝 3已完成 -->
          <template slot-scope="scope" v-if="scope.row.status == 1 || scope.row.status == 3 || scope.row.status == 4">
            <div v-if="scope.row.fp_time">开票时间：{{ scope.row.fp_time }}</div>
            <div v-if="scope.row.fp_time">发票代码：{{ scope.row.fp_code }}</div>
            <div v-if="scope.row.fp_time">号码：{{ scope.row.fp_num }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250px" v-if="canLook == 1">
          <!-- // 0待审核1通过2拒绝3已完成 -->
          <template slot-scope="scope">
            <el-button size="mini" type="info" v-if="scope.row.status == 1" @click="uploadFapiao(scope.row.id)">上传开票信息</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.status == 0" @click="agreenFapiao(scope.row.id)">通过</el-button>
            <el-button size="mini" type="danger" v-if="scope.row.status == 0" @click="refuseOrder(scope.row.id)">拒绝</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row v-if="canLook == 1">
        <el-button type="primary" plain @click="sureOrder">审核通过</el-button>
        <!-- <el-button type="info" plain @click="sendOrder">批量发货</el-button> -->
        <el-button type="success" plain @click="completeOrder">完成</el-button>
      </el-row>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 拒绝的对话框 -->
    <el-dialog title="拒绝申请" :visible.sync="refuseVisible" width="50%" @close="refuseDialogClosed">
      <el-form :model="refuseForm" :rules="refuseFormRules" ref="refuseFormRef" label-width="100px">
        <el-form-item label="拒绝理由" prop="refuseseasion">
          <el-input v-model="refuseForm.refuseseasion"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="refuseVisible = false">取 消</el-button>
        <el-button type="primary" @click="postRefuse">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 拒绝的对话框 -->
    <el-dialog title="上传开票资料" :visible.sync="fpVisible" width="50%" @close="fpDialogClosed">
      <el-form :model="fpForm" :rules="fpFormRules" ref="fpFormRef" label-width="100px">
        <el-form-item label="开票时间" prop="fp_time">
          <el-date-picker v-model="fpForm.fp_time" type="datetime" value-format="timestamp" placeholder="选择日期时间"> </el-date-picker>
        </el-form-item>
        <el-form-item label="发票代码" prop="fp_code">
          <el-input v-model="fpForm.fp_code"></el-input>
        </el-form-item>
        <el-form-item label="号码" prop="fp_num">
          <el-input v-model="fpForm.fp_num"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="fpVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureUploadfpInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


export default {
  data () {
    return {
      canLook: 1,
      exportUrl: 'https://hsapi.hsxsn.cn//fapiaoExportExcel?mPhone=' + localStorage.getItem('phone'),
      queryInfo: {
        query: '',
        agencyName: '',
        tid: 3,
        status: -1,
        type: 0,
        pagenum: 1,
        pagesize: 10
      },
      // statusValue: '状态',
      // statusOptions: [
      //   { label: '所有状态', value: -1 },
      //   { label: '待审核', value: 0 },
      //   { label: '已审核，待开具', value: 1 },
      //   { label: '已拒绝', value: 2 },
      //   { label: '已完成开具', value: 3 }
      // ],
      tabIndex: 0,
      // 0待审核1通过2拒绝3已完成
      statusValue: '全部',
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '待审核', id: 0 },
        { value: '已通过', id: 1 },
        { value: '已完成', id: 3 },
        { value: '已拒绝', id: 2 },
      ],

      typeValue: '发票类型',
      options: [
        { label: '所有类型', value: 3 },
        { label: '增值税普通电子发票', value: 0 },
        { label: '增值税专用发票', value: 1 },
        { label: '增值税普通发票', value: 2 },
      ],
      total: 0,
      orderlist: [],
      addressVisible: false,

      progressVisible: false,
      progressInfo: [],
      multipleSelection: [],
      multipleSelectionjson: null,

      refuseVisible: false,
      refuseForm: {
        refuseseasion: null
      },
      refuseFormRules: {
        refuseseasion: [
          { required: true, message: '请输入拒绝理由', trigger: 'blur' }
        ]
      },

      fpSelectId: 0,
      fpVisible: false,

      fpForm: {
        fp_time: null,
        fp_code: null,
        fp_num: null,
      },

      fpFormRules: {
        fp_time: [
          { required: true, message: '请选择时间', trigger: 'blur' }
        ],
        fp_code: [
          { required: true, message: '请输入发票代码', trigger: 'blur' }
        ],
        fp_num: [
          { required: true, message: '请输入号码', trigger: 'blur' }
        ],
      },
    }
  },


  created () {
    this.getOrderList()
  },

  methods: {
    handleClick (tab, event) {
      console.log(tab.index);
      this.tabIndex = tab.index;
      var selectIndex = tab.index - 1;
      if (tab.index == 3) {
        selectIndex = 3
      } else if (tab.index == 4) {
        selectIndex = 2
      }

      this.queryInfo.status = selectIndex
      this.filterSelect();
    },

    changeType (value) {
      console.log(value);
      this.queryInfo.tid = value
      this.queryInfo.pagenum = 1
      this.orderlist = [];
      this.total = 0;
      this.getOrderList(); // 通过接口获取数据的方法
    },

    changeInvoiceStatus (value) {
      console.log(value);
      this.queryInfo.status = value
      this.queryInfo.pagenum = 1
      this.orderlist = [];
      this.total = 0;
      this.getOrderList(); // 通过接口获取数据的方法
    },

    uploadFapiao (id) {
      this.fpSelectId = id;
      this.fpVisible = true
    },

    fpDialogClosed () {
      this.fpVisible = false
    },

    // 上传发票信息
    async sureUploadfpInfo () {
      this.$refs.fpFormRef.validate(async valid => {
        if (!valid) return

        const { data: res } = await this.$http.post('admin/invoice/uploadInfo', {
          fp_time: this.fpForm.fp_time,
          fp_code: this.fpForm.fp_code,
          fp_num: this.fpForm.fp_num,
          id: this.fpSelectId,
        })
        if (res.code !== 200) {
          return this.$message.error('操作失败！')
        }
        this.fpVisible = false
        this.$message.success('操作成功！')
        this.getOrderList()
      })
    },

    refuseDialogClosed () {
      this.refuseVisible = false
    },


    search () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },

    filterSelect () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {

      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list.length) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsapi.hsxsn.cn//fapiaoExportExcel?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsapi.hsxsn.cn//fapiaoExportExcel?mPhone=' + localStorage.getItem('phone')
      }
      console.log(this.exportUrl);
    },

    // 批量确认  0待审核1通过2拒绝3已完成
    async sureOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选！')
      }
      const confirmResult = await this.$confirm(
        '将已选中的申请修改为已通过，待开具, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/invoice/changeStatus', {
        data: this.multipleSelection,
        type: 1,
      })
      if (res.code !== 200) {
        return this.$message.error('确认失败！')
      }
      this.$message.success('确认成功！')
      this.getOrderList()
    },

    // 批量发货订单
    async sendOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选！')
      }
      const confirmResult = await this.$confirm(
        '将发货所有已选中的已确认申请，其余发货无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/invoice/changeStatus', {
        data: this.multipleSelection,
        type: 2,
      })
      if (res.code !== 200) {
        return this.$message.error('发货失败！')
      }
      this.$message.success('发货成功！')
      this.getOrderList()
    },

    // 批量完成订单
    async completeOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选！')
      }
      const confirmResult = await this.$confirm(
        '将确保所有已选中的都已经开票, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/invoice/changeStatus', {
        data: this.multipleSelection,
        type: 3,
      })
      if (res.code !== 200) {
        return this.$message.error('已完成操作失败！')
      }
      this.$message.success('已完成操作成功！')
      this.getOrderList()
    },

    // 拒绝订单
    async refuseOrder (id) {
      this.refuseVisible = true
      this.refuseID = id;
    },

    // 拒绝请求
    async postRefuse () {
      const { data: res } = await this.$http.post('admin/invoice/refuse', {
        refuseseasion: this.refuseForm.refuseseasion,
        id: this.refuseID,
      })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.refuseVisible = false
      this.$message.success('操作成功！')
      this.getOrderList()
    },

    // 通过
    async agreenFapiao (id) {
      const { data: res } = await this.$http.post('admin/invoice/agreen', {
        id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.getOrderList()
    },

    async getOrderList () {
      const { data: res } = await this.$http.get('admin/invoice/getList', {
        params: this.queryInfo
      })
      // console.log(res)
      if (res.code !== 200) {
        return this.$message.error('获取列表失败！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    exportOrder () {
      console.log('11111');
      this.getOrderList()
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}

.daochuA {
  width: 60px;
  height: 24px;
  line-height: 24px;
  align-items: center;
  background-color: blue;
  color: #fff;
  align-content: center;
  margin-left: 20px;
  display: inline-block;
  padding: 20rpx;
  font-size: 14px;
  text-decoration: none;
}
</style>
